import React from 'react'
import styled from 'styled-components'
import Recaptcha from 'react-recaptcha'
import Error from './Utils/Error'
import Spinner from './Utils/Spinner'
import Cookies from 'universal-cookie'
import { gaEvents } from '../analytics/events'
import { Link, withRouter } from 'react-router-dom'
import { withAuth } from './AuthContext'
import { withSearch } from './SearchContext'
import { isValidEmail } from '../utils/utils'
import { shouldTranslateTo } from '../utils/utils'
import { decode } from 'html-entities'
import {
  Title,
  Subtitle,
  Input,
  Button,
  ActionButtons,
  CustomSelect,
  CustomSubtitle,
  ContainerFlexRow,
  ContainerFlexColumn,
  CheckboxWrapper,
  CustomCheckbox,
  OutlineButton,
} from './Utils/CustomClasses'

const cookies = new Cookies()

const Container = styled.div`
  margin-top: -10px;

  @media screen and (max-width: 992px) and (min-width: 769px) {
    margin-top: 150px;
  }

  @media screen and (max-width: 768px) and (min-width: 426px) {
    margin-top: -20px;
  }

  @media screen and (max-width: 425px) {
    margin-top: -15px;
  }
`

const Header = styled.div`
  background-color: #f6f0e6;
`

const CustomContainerFlexRow = styled(ContainerFlexRow)`
  justify-content: space-evenly;
  align-items: center;

  @media screen and (max-width: 1024px) {
    flex-direction: row;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`

const HeaderText = styled.div`
  max-width: 50vw;
  flex-shrink: 0;

  @media screen and (max-width: 768px) {
    max-width: fit-content;
  }
`

const HeaderImage = styled.div`
  text-align: center;
  img {
    width: 100%;

    @media screen and (max-width: 768px) and (min-width: 601px) {
      width: 50%;
    }
  }
`

const BlueSubtitle = styled(CustomSubtitle)`
  color: #154549;
`

const CustomButtom = styled(Button)`
  padding: 18px 86px;
  a {
    padding: unset;
    height: auto;
  }
`

const FormWrapper = styled.div`
  width: -webkit-fill-available;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8vh 10% 4vh;
  text-align: center;

  @media screen and (max-width: 768px) {
    padding: 8vh 5% 4vh;
  }
`

const Form = styled.form`
  text-align: left;
  width: 40vw;
  min-width: 400px;

  @media screen and (max-width: 768px) {
    width: -webkit-fill-available !important;
    min-width: unset !important;
  }
`

const FormActions = styled.div`
  margin-top: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 3rem;

  button {
    width: -webkit-fill-available !important;
    white-space: nowrap;
  }

  @media screen and (max-width: 1024px) {
    gap: 2rem;
  }

  @media screen and (max-width: 480px) {
    gap: 1rem;
  }

  @media screen and (max-width: 425px) {
    flex-direction: column;
  }
`

const CustomCheckboxWrapper = styled(CheckboxWrapper)`
  margin-top: 0;
  margin-bottom: 30px;
`

const CustomCheckboxForm = styled(CustomCheckbox)`
  border: 2px solid rgba(17, 17, 19, 0.39);
  border-radius: 50%;
  margin-left: 6px;
  height: 30px;
  width: 30px;
`

const TextWrapper = styled.div`
  max-width: 885px;
`

const CustomInput = styled(Input)`
  height: 50px;
`

const RecaptchaWrapper = styled.div`
  text-align: center;

  #g-recaptcha {
    & > div {
      margin: 0 auto;
    }
  }
`

const CustomOutlineButton = styled(OutlineButton)`
  max-width: -webkit-fill-available !important;
`

const ErrorWrapper = styled.div`
  margin: 30px 0 0;
`

const LinkSub = styled.p`
  text-align: center;
  a {
    font-size: 16px;
    text-decoration: none;
    font-weight: 400;
    color: #000;
    margin-bottom: 0;
    width: fit-content;

    &:hover {
      cursor: pointer;
      color: #0bac5d;
    }
  }
`

const Modal = ({ handleClose, showModal, data, modalContent, children }) => {
  const showHideClassName = showModal
    ? 'modal-aaa aaa-display-block'
    : 'modal-aaa aaa-display-none'

  return (
    <div className={showHideClassName}>
      <section className="modal-aaa-main">
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            {modalContent == 'Terms of Supply'
              ? decode(data[36])
              : modalContent == 'Terms of Use'
              ? decode(data[38])
              : decode(data[40])}
          </h5>
          <button type="button" className="close" onClick={handleClose}>
            <span aria-hidden="true">×</span>
          </button>
        </div>
        {children}
        <div className="modal-footer">
          <button
            className="btn btn-secondary"
            type="button"
            onClick={handleClose}
          >
            Close
          </button>
        </div>
      </section>
    </div>
  )
}

const SignupMailingList = (props) => {
  // Component logic goes here
  //const [title, setTitle] = React.useState("");
  const [firstName, setFirstName] = React.useState('')
  //const [secondName, setSecondName] = React.useState("");
  const [over50, setOver50] = React.useState('')
  const [email, setEmail] = React.useState('')
  const [emailConfirmation, setEmailConfirmation] = React.useState('')
  const [country, setCountry] = React.useState('')
  const [citySelect, setCitySelect] = React.useState('')
  const [cityInput, setCityInput] = React.useState('')
  const [isNewCity, setIsNewCity] = React.useState(false)
  const [cities, setCities] = React.useState([])
  //const [titleError, setTitleError] = React.useState(false);
  const [firstNameError, setFirstNameError] = React.useState(false)
  //const [secondNameError, setSecondNameError] = React.useState(false);
  const [emailError, setEmailError] = React.useState(false)
  const [emailConfirmationError, setEmailConfirmationError] =
    React.useState(false)
  const [over50Error, setOver50Error] = React.useState(false)
  const [countryError, setCountryError] = React.useState(false)
  const [cityError, setCityError] = React.useState(false)
  const [captchaVerified, setCaptchaVerified] = React.useState(false)
  const [error, setError] = React.useState({})
  const [pageText, setPageText] = React.useState([])
  const [pageTextModal, setPageTextModal] = React.useState([])
  const [modalContent, setModalContent] = React.useState('')
  const [showModal, setShowModal] = React.useState(false)
  const [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue, setPageState) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageState(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('facebook-host', language, setPageText)

    getPageText('signup', language, setPageTextModal)
  }, [])

  /*
    const updateTitle = (e) => {
        setTitleError(false);
        setError(null);
        setTitle(e["value"]);
    };
    */

  const updateFirstName = (e) => {
    setFirstNameError(false)
    setError(null)
    setFirstName(e)
  }

  /*
    const updateSecondName = (e) => {
        setSecondNameError(false);
        setError(null);
        setSecondName(e);
    };
    */

  const updateOver50 = (e) => {
    setOver50Error(false)
    setError(null)
    setOver50(e.value)
  }

  const updateEmail = (e) => {
    setEmailError(false)
    setEmailConfirmationError(false)
    setError(null)
    setEmail(e)
  }
  const updateEmailConfirmation = (e) => {
    setEmailConfirmationError(false)
    setEmailError(false)
    setError(null)
    setEmailConfirmation(e)
  }

  const updateCountry = async ({ value }) => {
    setCitySelect('')
    setCityInput('')
    setCountryError(false)
    setError(null)
    setCountry(value)
    try {
      const response = await axios.get(`/api/cities/${value}`)
      let citiesResult = response.data.map((city) => {
        return { value: city.id, label: city.city }
      })
      setCities(citiesResult)
    } catch (e) {
      console.log('Error getting cities: ', e)
    }
  }

  const updateCity = (e) => {
    setCityError(false)
    setError(null)
    if (isNewCity) {
      setCityInput(e)
    } else {
      setCityInput(e.label)
      setCitySelect(e.value)
    }
  }

  const updateIsNewCity = (e) => {
    setError(null)
    setCityInput('')
    setCitySelect(0)
    if (isNewCity) {
      setIsNewCity(false)
    } else {
      setIsNewCity(true)
    }
  }

  const { history, search } = props

  const countrySelected = search.countriesNice.find((c) => c.value === country)

  var callback = function () {
    console.log('--')
  }

  var verifyCallback = function (response) {
    setError(null)
    if (response) {
      setCaptchaVerified(true)
    }
  }

  const SubmitForm = (e) => {
    e.preventDefault()
    //setTitleError(false);
    setFirstNameError(false)
    //setSecondNameError(false);
    setOver50Error(false)
    setEmailError(false)
    setEmailConfirmationError(false)
    setCountryError(false)
    setCityError(false)

    /*
        // Validate title
        if (!title) {
            setTitleError(true);
            setError("Please add your title");
            return;
        }
        */

    // Validate first name
    if (!firstName) {
      setFirstNameError(true)
      setError('Please enter your first name')
      return
    }

    /*
        // Validate last name
        if (!secondName) {
            setSecondNameError(true);
            setError("Please enter your last name");
            return;
        }
        */

    // Validate over 50
    if (!over50) {
      setOver50Error(true)
      setError('Please confirm you are aged 50 or over')
      return
    }

    if (over50 == 'No') {
      setOver50Error(true)
      setError('Freebird Club is available to over 50s only')
      return
    }

    // Validate email
    if (email && emailConfirmation) {
      if (!isValidEmail(email)) {
        setEmailError(true)
        setError('Please enter a valid email address')
        return
      }
      if (email !== emailConfirmation) {
        setEmailError(true)
        setEmailConfirmationError(true)
        setError('Emails do not match')
        return
      }
    } else {
      if (email) {
        setEmailConfirmationError(true)
        setError('Please confirm your email address')
      } else {
        setEmailError(true)
        setEmailConfirmationError(true)
        setError('Please enter an email address')
      }
      return
    }

    // Validate country
    if (!country) {
      setCountryError(true)
      setError('Please choose your country of residence')
      return
    }

    // Validate city
    if (isNewCity) {
      if (!cityInput) {
        setCityError(true)
        setError('Please choose your city of residence')
        return
      }
    } else {
      if (!citySelect) {
        setCityError(true)
        setError('Please choose your city of residence')
        return
      }
    }

    // Validate captcha
    if (!captchaVerified) {
      setError('Please complete Recaptcha')
      return
    }

    setLoading(true)

    var member = {
      user_type: 'mailing-list',
      //title: title,
      title: 'Mr',
      firstName: firstName,
      //secondName: secondName,
      secondName: 'mailing-list',
      overfifty: over50,
      dob: '1968-01-01',
      country: country,
      city: cityInput,
      cities: cities,
      locationId: isNewCity ? null : citySelect,
      email: email,
      is_new_city: isNewCity,
      isVerified: false,
      address_line: '',
      second_address_line: '',
      country_region: '',
      languages: [],
      discount_code:
        cookies.get('dC') != '' && cookies.get('dC') != null
          ? cookies.get('dC')
          : null,
      landing_page_code:
        cookies.get('tT') != '' && cookies.get('tT') != null
          ? cookies.get('tT')
          : null,
      source_code:
        cookies.get('sC') != '' && cookies.get('sC') != null
          ? cookies.get('sC')
          : null,
      price_code:
        cookies.get('pC') != '' && cookies.get('pC') != null
          ? cookies.get('pC')
          : null,
      currency_value:
        cookies.get('cV') != '' && cookies.get('cV') != null
          ? cookies.get('cV')
          : null,
      language_code:
        cookies.get('lC') != '' && cookies.get('lC') != null
          ? cookies.get('lC')
          : null,
      utm_source:
        cookies.get('utmS') != '' && cookies.get('utmS') != null
          ? cookies.get('utmS')
          : null,
      utm_medium:
        cookies.get('utmM') != '' && cookies.get('utmM') != null
          ? cookies.get('utmM')
          : null,
      utm_campaign:
        cookies.get('utmCa') != '' && cookies.get('utmCa') != null
          ? cookies.get('utmCa')
          : null,
      utm_content:
        cookies.get('utmCo') != '' && cookies.get('utmCo') != null
          ? cookies.get('utmCo')
          : null,
    }

    const data = {
      member: member,
    }

    axios
      .post('/api/register-member', data)
      .then((response) => {
        gaEvents.eventGeneric(
          'form_submit',
          'submitted',
          'Member interest form'
        )
        gaEvents.mailingListSignup(response.data.id)

        axios.post('/api/ml-signup-mailing-list', member).catch((err) => {
          console.log('err: ' + err)
        })

        history.push('/signup-ml-submitted')
      })
      .catch((err) => {
        setError(err)
        setLoading(false)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const modalShow = (e) => {
    e.preventDefault()
    setModalContent(e.target.getAttribute('data-title'))
    setShowModal(true)
  }

  const modalHide = (e) => {
    setShowModal(false)
  }

  if (pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }
  return (
    <>
      {loading && <Spinner />}
      <Container>
        <Header>
          <CustomContainerFlexRow
            gap="50px"
            padding="10vh 40px 10vh 5vw"
            paddingSm="5vh 4vw 5vh 4vw"
          >
            <HeaderText>
              <Title
                size="2.5rem"
                sizemd="2.5rem"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[0]}`,
                }}
              ></Title>
              <Subtitle
                size="1.3rem"
                sizemd="1rem"
                margin="30px 0 50px 0"
                marginmd="20px 0 28px 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[3]}`,
                }}
              />
              <CustomButtom
                onClick={() =>
                  document.getElementById('form').scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'nearest',
                  })
                }
              >
                <Link>{pageText[4]}</Link>
              </CustomButtom>
            </HeaderText>
            <HeaderImage>
              <img src={'/images/facebook-host/header.png'} />
            </HeaderImage>
          </CustomContainerFlexRow>
        </Header>

        {/* FORM */}
        <ContainerFlexColumn
          background="#FFFBF4"
          center
          gap="50px"
          gapMd="30px"
          padding="0 80px 68px 80px"
          paddingSm="0 20px 68px 20px"
        >
          <FormWrapper id="form">
            <TextWrapper>
              <Title
                size="2.8rem"
                sizemd="2.5rem"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[5]}`,
                }}
              ></Title>
              <Subtitle
                bold
                size="1.4rem"
                sizemd="1.3rem"
                margin="50px 0 0 0"
                marginmd="40px 0 0 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[6]}`,
                }}
              />
              <CustomSubtitle
                size="1.2rem"
                sizemd="1.1rem"
                margin="40px 0 0 0"
                marginmd="20px 0 0 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[7]}`,
                }}
              />
              <CustomSubtitle
                size="1.2rem"
                sizemd="1.1rem"
                margin="20px 0 60px 0"
                marginmd="10px 0 40px 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[8]}`,
                }}
              />
            </TextWrapper>

            <Form onSubmit={(e) => SubmitForm(e)}>
              {/* 
                            Title
                            <CustomSubtitle
                                bold
                                size="18px"
                                margin="0 0 11px 0px"
                                dangerouslySetInnerHTML={{
                                    __html: `${pageText[31]}`,
                                }}
                            />
                            <CustomSelect
                                placeholder={pageText[32]}
                                defaultValue={{
                                    value: title ? title : "",
                                    label: title ? title : "Select...",
                                }}
                                className={titleError && "error-border"}
                                isDisabled={false}
                                isLoading={false}
                                isClearable={true}
                                isRtl={false}
                                isSearchable={true}
                                name="title"
                                options={[
                                    {
                                        value: pageText[32],
                                        label: pageText[32],
                                    },
                                    {
                                        value: pageText[33],
                                        label: pageText[33],
                                    },
                                    {
                                        value: pageText[34],
                                        label: pageText[34],
                                    },
                                ]}
                                onChange={(e) => updateTitle(e)}
                            />
                            */}
              {/* First Name */}
              <BlueSubtitle
                bold
                size="18px"
                margin="0 0 11px 0px"
                dangerouslySetInnerHTML={{
                  __html: pageText[9],
                }}
              />
              <Input
                id="firstName"
                type="text"
                name="firstName"
                className={firstNameError && 'error-border'}
                placeholder={pageText[9]}
                value={firstName}
                onChange={(e) => updateFirstName(e.target.value)}
              />

              {/* 
                            Last Name
                            <BlueSubtitle
                                bold
                                size="18px"
                                margin="0 0 11px 0px"
                                dangerouslySetInnerHTML={{
                                    __html: pageText[10],
                                }}
                            />
                            <Input
                                id="secondName"
                                type="text"
                                name="secondName"
                                className={secondNameError && "error-border"}
                                placeholder={pageText[10]}
                                value={secondName}
                                onChange={(e) =>
                                    updateSecondName(e.target.value)
                                }
                            />
                            */}

              {/* Over 50? */}
              <BlueSubtitle
                bold
                size="18px"
                margin="0 0 11px 0px"
                dangerouslySetInnerHTML={{
                  __html: pageText[11],
                }}
              />
              <CustomSelect
                width="-webkit-fill-available"
                placeholder={'Yes'}
                defaultValue={{
                  value: over50 ? over50 : '',
                  label: over50 ? over50 : 'Select...',
                }}
                className={over50Error && 'error-border'}
                isDisabled={false}
                isLoading={false}
                isClearable={false}
                isRtl={false}
                isSearchable={true}
                name="over50"
                options={[
                  {
                    value: 'Yes',
                    label: pageText[13],
                  },
                  {
                    value: 'No',
                    label: pageText[14],
                  },
                ]}
                onChange={(e) => updateOver50(e)}
              />

              {/* Email */}
              <BlueSubtitle
                bold
                size="18px"
                margin="0 0 11px 0px"
                dangerouslySetInnerHTML={{
                  __html: pageText[15],
                }}
              />
              <Input
                id="custodian-email"
                type="email"
                name="email"
                className={emailError && 'error-border'}
                placeholder={pageText[16]}
                value={email}
                onChange={(e) => updateEmail(e.target.value)}
              />

              {/* Confirm Email */}
              <BlueSubtitle
                bold
                size="18px"
                margin="0 0 11px 0px"
                dangerouslySetInnerHTML={{
                  __html: pageText[17],
                }}
              />
              <Input
                id="custodian-emailConfirmation"
                type="emailConfirmation"
                name="emailConfirmation"
                className={emailConfirmationError && 'error-border'}
                placeholder={pageText[18]}
                value={emailConfirmation}
                onChange={(e) => updateEmailConfirmation(e.target.value)}
              />

              {/* Country */}
              <BlueSubtitle
                bold
                size="18px"
                margin="0 0 11px 0px"
                dangerouslySetInnerHTML={{
                  __html: pageText[19],
                }}
              />
              <CustomSelect
                width="-webkit-fill-available"
                placeholder={pageText[20]}
                defaultValue={'Select..'}
                value={countrySelected}
                className={countryError && 'error-border'}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                name="country"
                options={search.countriesNice}
                onChange={(e) => updateCountry(e)}
              />
              {/* Town */}
              {!isNewCity ? (
                <div>
                  <BlueSubtitle
                    bold
                    size="18px"
                    margin="0 0 11px 0px"
                    dangerouslySetInnerHTML={{
                      __html: pageText[21],
                    }}
                  />
                  <CustomSelect
                    width="-webkit-fill-available"
                    placeholder={pageText[22]}
                    defaultValue={'Select..'}
                    className={cityError && 'error-border'}
                    isDisabled={false}
                    isLoading={false}
                    isClearable={true}
                    isRtl={false}
                    isSearchable={true}
                    name="town"
                    options={cities}
                    value={
                      cityInput === ''
                        ? 'Select..'
                        : {
                            label: cityInput,
                            value: citySelect,
                          }
                    }
                    onChange={(e) => updateCity(e)}
                  />
                </div>
              ) : (
                <div>
                  <BlueSubtitle
                    bold
                    size="18px"
                    margin="0 0 11px 0px"
                    dangerouslySetInnerHTML={{
                      __html: pageText[23],
                    }}
                  />
                  <CustomInput
                    id="city"
                    type="text"
                    name="town"
                    className={cityError && 'error-border'}
                    placeholder={pageText[24]}
                    value={cityInput}
                    onChange={(e) => updateCity(e.target.value)}
                  />
                </div>
              )}
              <CustomCheckboxWrapper>
                <CustomCheckboxForm onClick={(e) => updateIsNewCity(e.target)}>
                  {isNewCity && <img src="/images/check-icon.svg" />}
                </CustomCheckboxForm>
                {pageText[25]}
              </CustomCheckboxWrapper>
              <RecaptchaWrapper>
                <Recaptcha
                  sitekey={recaptchaPublicKey}
                  render="explicit"
                  verifyCallback={verifyCallback}
                  onloadCallback={callback}
                />
              </RecaptchaWrapper>

              {/*}
                            <FormActions>
                                <ActionButtons
                                    padding="12px 14px"
                                    type="submit"
                                >
                                    {pageText[26]}
                                </ActionButtons>

                                <CustomOutlineButton padding="12px 14px">
                                    <Link to="/">{pageText[27]}</Link>
                                </CustomOutlineButton>
                            </FormActions>
                            */}

              <FormActions>
                <ActionButtons padding="12px 14px" type="submit">
                  {pageText[26]}
                </ActionButtons>
              </FormActions>

              <ErrorWrapper>{error && <Error error={error} />}</ErrorWrapper>

              <LinkSub>
                <Link
                  onClick={(e) => modalShow(e)}
                  data-title="Terms of Supply"
                >
                  {pageText[28]}
                </Link>{' '}
                <br />
                <Link onClick={(e) => modalShow(e)} data-title="Terms of Use">
                  {pageText[29]}
                </Link>{' '}
                <br />
                <Link onClick={(e) => modalShow(e)} data-title="Privacy Policy">
                  {pageText[30]}
                </Link>
              </LinkSub>
            </Form>
          </FormWrapper>
        </ContainerFlexColumn>
      </Container>
      <div
        style={{
          zIndex: 9999999,
          position: 'absolute',
          height: '40px',
          width: '200px',
        }}
      >
        <Modal
          showModal={showModal}
          handleClose={modalHide}
          data={pageTextModal}
          modalContent={modalContent}
        >
          <div
            className="modal-body"
            dangerouslySetInnerHTML={{
              __html:
                modalContent == 'Terms of Supply'
                  ? decode(pageTextModal[35])
                  : modalContent == 'Terms of Use'
                  ? decode(pageTextModal[39])
                  : decode(pageTextModal[41]),
            }}
          ></div>
        </Modal>
      </div>
    </>
  )
}

export default withRouter(withSearch(withAuth(SignupMailingList)))
